import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';

export const fetchMealPlanDetails = createAsyncThunk(
  'mealPlanDetails/fetchMealPlanDetails',
  async (_, { rejectWithValue }) => {
    try {
      
      const response = await api.get(`/api/meal_plan_details/`);
      return response.data;
    } catch (error) {
      // console.error('Fetch meal plan details error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to fetch meal plan details.');
    }
  }
);

// Δημιουργία Thunks για την ανάκτηση MealPlanDetails ενός συγκεκριμένου μήνα
export const fetchMealPlansForMonth = createAsyncThunk(
  'mealPlanDetails/fetchMealPlansForMonth',
  async ({ month, year }, { rejectWithValue }) => {
    try {
      
      const config = {
        params: {
          month: month,
          year: year,
        },
      };
      const response = await api.get(`/api/meal_plan_details/filter_by_month/`, config);
      return response.data;
    } catch (error) {
      //console.error('Error fetching meal plans for the month:', error.response);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch meal plans for the month.');
    }
  }
);


export const addMealPlanDetail = createAsyncThunk(
  'mealPlanDetails/addMealPlanDetail',
  async (mealPlanData, { rejectWithValue }) => {
    try {
      
      const response = await api.post(`/api/meal_plan_details/`, mealPlanData,);
      return response.data;
    } catch (error) {
      // console.error('Add meal plan detail error response:', error);
      return rejectWithValue(error.response.data.message || 'Failed to add meal plan detail.');
    }
  }
);

export const deleteMealPlanDetail = createAsyncThunk(
  'mealPlanDetails/deleteMealPlanDetail',
  async (mealPlanID, { rejectWithValue }) => {
    try {
      
      await api.delete(`/api/meal_plan_details/${mealPlanID}/`, );
      return mealPlanID;
    } catch (error) {
      // console.error('Delete meal plan detail error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to delete meal plan detail.');
    }
  }
);

export const updateMealPlanDetail = createAsyncThunk(
  'mealPlanDetails/updateMealPlanDetail',
  async ({ mealPlanID, mealPlanData }, {  rejectWithValue }) => {
    try {
      
      const response = await api.put(`/api/meal_plan_details/${mealPlanID}/`, mealPlanData, );
      return response.data;
    } catch (error) {
      // console.error('Update meal plan detail error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to update meal plan detail.');
    }
  }
);

// Δημιουργία του Slice
const mealPlanDetailSlice = createSlice({
  name: 'mealPlanDetails',
  initialState: {
    details: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMealPlanDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMealPlanDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.details = action.payload;
      })
      .addCase(fetchMealPlanDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch meal plan details.';
      })
      .addCase(addMealPlanDetail.fulfilled, (state, action) => {
        state.details.push(action.payload);
      })
      .addCase(addMealPlanDetail.rejected, (state, action) => {
        state.error = action.payload || 'Failed to add meal plan detail.';
      })
      .addCase(deleteMealPlanDetail.fulfilled, (state, action) => {
        state.details = state.details.filter(detail => detail.id !== action.payload);
      })
      .addCase(deleteMealPlanDetail.rejected, (state, action) => {
        state.error = action.payload || 'Failed to delete meal plan detail.';
      })
      .addCase(updateMealPlanDetail.fulfilled, (state, action) => {
        const index = state.details.findIndex(detail => detail.id === action.payload.id);
        if (index !== -1) {
          state.details[index] = action.payload;
        }
      })
      .addCase(updateMealPlanDetail.rejected, (state, action) => {
        state.error = action.payload || 'Failed to update meal plan detail.';
      })
      .addCase(fetchMealPlansForMonth.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMealPlansForMonth.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.details = action.payload;
      })
      .addCase(fetchMealPlansForMonth.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch meal plans for the month.';
      });
  }
});

export default mealPlanDetailSlice.reducer;